<template>
  <div class="FilterDropdown">
    <div class="filter-wrapper">
      <div
        class="filter-group"
        v-for="(filters, index) in filterData"
        :key="index"
      >
        <h6 class="heading" v-if="filters.key !== 'imgUrl'">
          {{ filters.key }}
        </h6>
        <ul class="filter-group-wrapper" v-if="filters.key !== 'imgUrl'">
          <!--<li>-->
          <!--<b-form-checkbox value="All" name="flavour-3a">-->
          <!--All-->
          <!--</b-form-checkbox>-->
          <!--</li>-->
          <li v-for="(filter, index) in filters.propertyValueList" :key="index">
            <b-form-checkbox
              v-model="propertyFilterList"
              :value="[{ key: filters.key, propertyValueList: [filter] }]"
              name="flavour-3a"
            >
              {{ filter.value }}
            </b-form-checkbox>
            <span class="ml-2 text-black-50">
              {{ filter.count }}
            </span>
          </li>
        </ul>
        <!--<a class="more" href=""-->
        <!--v-if="filters.key !== 'imgUrl'">More-->
        <!--<font-awesome-icon icon="angle-down"></font-awesome-icon>-->
        <!--</a>-->
      </div>
    </div>
    <hr />
    <div class="filter-footer">
      <b-dropdown-item>
        <b-button class="text-dark" variant="link" @click="cancelFilter"
          >Cancel</b-button
        >
      </b-dropdown-item>
      <b-dropdown-item>
        <b-button size="lg" variant="primary" pill @click="applyFilter"
          >Apply</b-button
        >
      </b-dropdown-item>
    </div>
  </div>
</template>

<script>
import { videoApi } from "../../services/videoApi";

export default {
  props: {
    filterData: Array,
    categoryId: String
  },
  data() {
    return {
      propertyFilterList: [],
      selected: [] // Must be an array reference!
    };
  },
  methods: {
    applyFilter() {
      // console.log(" this.propertyFilterList", this.propertyFilterList);
      if (!this.categoryId) {
        const filterRequest = {
          category_id: this.categoryId,
          filter_data: {
            propertyFilterList: this.propertyFilterList
          }
        };
        videoApi.filterAllCourses(filterRequest).then(res => {
          this.$emit("applyFilter", res.data);
        });
      } else {
        const filterRequest = {
          category_id: this.categoryId,
          filter_data: {
            propertyFilterList: this.propertyFilterList
          }
        };
        videoApi.filterCoursesByCategory(filterRequest).then(res => {
          const CourseArray = [];
          if (res.data.courseResponse.length > 0) {
            res.data.courseResponse.forEach(course => {
              CourseArray.push(course);
            });
            if (res.data.subCourses.length > 0) {
              res.data.subCourses.forEach(subCourse => {
                if (subCourse.courseResponse.length > 0) {
                  subCourse.courseResponse.forEach(course => {
                    CourseArray.push(course);
                  });
                  if (subCourse.subCourses.length > 0) {
                    subCourse.subCourses.forEach(subCour => {
                      if (subCour.courseResponse.length > 0) {
                        subCour.courseResponse.forEach(cour => {
                          CourseArray.push(cour);
                        });
                      }
                    });
                  }
                }
              });
            }
          }
          this.$emit("applyFilter", CourseArray);
        });
      }
      this.propertyFilterList = [];
    },
    cancelFilter() {
      this.propertyFilterList = [];
    }
  }
};
</script>
